import { render, staticRenderFns } from "./HistoryTable.vue?vue&type=template&id=158e9571&scoped=true"
import script from "./HistoryTable.vue?vue&type=script&lang=ts"
export * from "./HistoryTable.vue?vue&type=script&lang=ts"
import style0 from "./HistoryTable.vue?vue&type=style&index=0&id=158e9571&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158e9571",
  null
  
)

export default component.exports